import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss'],
})
export class ImageUploaderComponent {
  @Input() accept: string = '.jpg,.jpeg,.png'; // Yüklenebilir dosya türlerini belirtmek için
  @Input() src?: string = ''; // Yüklenebilir dosya türlerini belirtmek için
  @Output() fileSelected = new EventEmitter<string | null>(); // Resim seçildiğinde tetiklenen olay

  file: File | null = null;
  imageSrc: string | ArrayBuffer | null = null;
  maxFileSize = 50 * 1024; //KB
  maxRetries = 19; // Maksimum deneme sayısı
  qualityStep = 0.05; // Kalite adım boyutu
  maxWidth = 1024; // Maksimum genişlik
  maxHeight = 1024; // Maksimum yükseklik

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.imageSrc = '';
    if (changes['src'] && changes['src'].currentValue) {
      this.imageSrc = environment.imageUrl+changes['src'].currentValue;
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files ? input.files[0] : null;
    if (file) {
      if (!file.type.includes('svg')) {
        this.resizeImage(file)
          .then((resizedFile) => {
            this.file = resizedFile;
            this.fileToBase64(resizedFile).then((base64) => {
              this.fileSelected.emit(base64);
            });
            this.previewImage(resizedFile);
          })
          .catch((error) => {
            console.error('Resim küçültme işlemi başarısız oldu.', error);
          });
      } else {
        //svg formatında gelenler
        this.readSVGFile(file)
          .then((base64) => {
            this.fileSelected.emit(base64); // Base64 formatında SVG içeriğini dışarıya aktarma
            this.imageSrc = base64
          })
          .catch((error) => {
            console.error('SVG dosyasını okuma işlemi başarısız oldu.', error);
          });
      }
    }
  }
  readSVGFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = () => {
        // FileReader'in result özelliği dosyanın içeriğini metin olarak döner
        const result = reader.result as string;
        resolve(result);
      };
  
      reader.onerror = () => {
        reject(new Error('SVG dosyasını okuma hatası.'));
      };
      
      // SVG dosyasını metin olarak okuma işlemini başlat
      reader.readAsText(file);
    });
  }

   resizeImage(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        // Resim ebatlarını koruyarak yeniden boyutlandır
        const aspectRatio = img.width / img.height;
        let width = img.width;
        let height = img.height;

        if (width > this.maxWidth) {
          width = this.maxWidth;
          height = width / aspectRatio;
        }
        if (height > this.maxHeight) {
          height = this.maxHeight;
          width = height * aspectRatio;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        this.compressImage(canvas, file.type, 1, this.maxRetries)
          .then((compressedBlob) => {
            const resizedFile = new File([compressedBlob], file.name, {
              type: file.type,
            });
            resolve(resizedFile);
          })
          .catch((error) => reject(error));
      };

      img.onerror = (error) => reject(error);
    });
  }

  compressImage(
    canvas: HTMLCanvasElement,
    type: string,
    quality: number,
    retries: number
  ): Promise<Blob> {
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) {
            if (blob.size <= this.maxFileSize || retries <= 0) {
              resolve(blob);
            } else {
              // Kaliteyi azalt ve tekrar dene
              this.compressImage(
                canvas,
                type,
                quality - this.qualityStep,
                retries - 1
              )
                .then(resolve)
                .catch(reject);
            }
          } else {
            reject(new Error('Resim sıkıştırma işlemi başarısız oldu.'));
          }
        },
        type,
        quality
      );
    });
  }

  private previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageSrc = environment.imageUrl+reader.result;
    };
    reader.readAsDataURL(file);
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
}
